// #region Global Imports
import * as React from 'react';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import { getFragmentData } from '@generated/fragment-masking';
import type { IProps } from '@components/Paragraphs/ParagraphFile/ParagraphFile';
// #endregion Local Imports

export const ParagraphFileFragment = gql(/* GraphQL */ `
  fragment ParagraphFileFragment on ParagraphFile {
    fieldFile {
      file: entity {
        __typename
        id: uuid
        name
        ... on MediaFile {
          mediaFile: fieldMediaFile {
            __typename
            media: entity {
              url
              mime: filemime
            }
          }
        }
      }
    }
  }
`);

export const ParagraphFile: React.FunctionComponent<IProps.ParagraphFile> = ({
  paragraph: _paragraph,
}) => {
  const paragraph = getFragmentData(ParagraphFileFragment, _paragraph);

  return (
    <div>
      {paragraph.fieldFile?.map((item): React.ReactElement => {
        const file = item?.file;
        if (file?.__typename === 'MediaFile') {
          const mediaFile = file.mediaFile;
          if (mediaFile?.__typename === 'FieldMediaFileFieldMediaFile') {
            return (
              <p key={file.id}>
                <a
                  href={String(mediaFile.media?.url)}
                  rel="noreferrer"
                  target={
                    mediaFile.media?.mime?.includes('pdf') ? '_blank' : ''
                  }
                >
                  {file.name}
                </a>
              </p>
            );
          }
        }

        return <></>;
      })}
    </div>
  );
};
